import { createContext } from "react";
const SitesContext = createContext();
export default SitesContext;